import React from 'react';
import AddEditCampaignForm from 'ui-component/Campaign/AddEditCampaignForm';

function EditCampaign () {
  return (
    <div>
      <AddEditCampaignForm title="Edit Campaign" />
    </div>
  )
}

export default EditCampaign;